import React from 'react';
import { Button, Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Formik, FormikHelpers, Form } from 'formik';
import { yupMultipleFiles } from '@utils/yup';
import * as Yup from 'yup';

import { BackButton, FormGroupControl } from '@components/Base';
import { userClaimAdditionalDocumentsUpload } from './action';
import { useRouteParam } from '@hooks/params';
import i18n from '@components/i18n';

export type FormValues = {
  additionalDocuments: File[] | null;
};

const initialValues: FormValues = {
  additionalDocuments: [],
};

const MAX_SUPPORTING_DOCUMENTS = 5;
const groupProps = { className: 'mb-3' };

const validationSchema = Yup.object({
  additionalDocuments: yupMultipleFiles()
    .default([])
    .test('required', i18n.t('validation:required'), (files: File[]) => files && files.length > 0)
    .test(
      'max',
      i18n.t('validation:limitOutOfRange', { max: MAX_SUPPORTING_DOCUMENTS }),
      (files: File[]) => files && files.length <= MAX_SUPPORTING_DOCUMENTS,
    ),
});

const ClaimAdditionalDocuments = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const claimableType = useRouteParam('claimableType');
  const claimableId = useRouteParam('claimableId');

  const handleSubmit = (values: FormValues, { setSubmitting }: FormikHelpers<FormValues>) => {
    dispatch(userClaimAdditionalDocumentsUpload({ ...values, claimableType, claimableId }));
    setSubmitting(false);
  };

  return (
    <>
      <BackButton className="mb-4" />
      <Card>
        <Card.Body>
          <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
            {({ isSubmitting, isValid }) => (
              <Form>
                <FormGroupControl
                  multiple
                  required
                  type="file"
                  name="additionalDocuments"
                  label={t('common:additionalDocuments')}
                  groupProps={groupProps}
                />

                <Button type="submit" disabled={isSubmitting || !isValid}>
                  {t('common:submit')}
                </Button>
              </Form>
            )}
          </Formik>
        </Card.Body>
      </Card>
    </>
  );
};

export { ClaimAdditionalDocuments };
